const releasesValidationNL = {
    "add": {
        "releaseName": {
            "required": 'De naam van de release is verplicht',
            "length": 'De naam van de release moet meer dan 2 en minder dan 120 tekens lang zijn',
            "noForwardSlash": 'De naam van de release mag geen schuine streep (/) bevatten',
            "matchTrack": 'Voor een release met één nummer moet de naam van de release overeenkomen met het nummer.',
            // validCharacters: 'De naam van de release mag alleen bestaan uit alfabetische tekens, cijfers, spaties en underscores'
            },
            "releaseVersion": {
                "length": 'De versie van de release moet meer dan 2 en minder dan 120 tekens lang zijn',
                "validCharacters": 'De versie van de release mag alleen bestaan uit alfabetische tekens, cijfers, spaties en underscores',
                "missingOne": 'Je release bestaat uit slechts één nummer dat geen Original Mix is, daarom moet de aangepaste track mixnaam worden ingevoerd in de Release Versie.',
                "missingTwo": 'Als een release meer inhoud biedt dan de standaardversie of het een andere versie is van een al uitgebracht album/release, moet je de Release Versie invoeren.',
                "invalid": 'Voor een release met één nummer zonder Mix Naam (Original Mix), moet de Release Versie leeg worden gelaten. Wis de Release Versie of voeg een Mix Naam toe aan het nummer.'
            },
            "releaseLanguage": {
                "required": 'Releasetaal is verplicht. Selecteer de taal van je releasenaam.'
            },
            "releaseEAN_UPC": {
                "required": "EAN / UPC is vereist.",
                "length": "Het EAN-nummer moet precies 13 tekens lang zijn.",
                "isValidEAN": "De waarde is geen geldige EAN. Als u een nieuwe release invoert, voer dan een correcte EAN in. Als u een backcatalogus uploadt en de EAN is ongeldig, neem dan contact met ons op."
            },
            "releaseLabel": {
                "required": 'Selecteer je label.'
            },
            "releaseCopyright": {
                "required": 'Je moet de Copyright Eigenaar invoeren. Meestal is dat je label.'
            },
            "releaseCopyrightYear": {
                "required": 'Voer het copyrightjaar in waarin deze release zal worden (werd) gepubliceerd.',
                "regexp": 'Voer het geldige copyrightjaar in'
            },
            "releaseCopyrightPublisher": {
                "required": 'Je moet de Uitgever Eigenaar invoeren. Meestal is dat je label.'
            },
            "releaseCopyrightYearPublisher": {
                "required": 'Voer het copyrightjaar in waarin deze release zal worden (werd) gepubliceerd.',
                "regexp": 'Voer het geldige copyrightjaar in'
            },
            "releaseGenre": {
                "required": 'Selecteer je release Genre.'
            },
            "releaseSubGenre": {
                "required": 'Selecteer je release Sub-Genre'
            },
            "releaseCatalogNumber": {
                "required": 'Voer een uniek release catalogusnummer in.',
                "length": 'Minimaal 4 en maximaal 16 tekens.',
                "validFormat": 'Voer je categorienummer in zonder spaties, alleen HOOFDLETTERS en cijfers. De eerste twee tekens moeten HOOFDLETTERS zijn. MM001, MMD001, MM0001 ... '
            },
            "releaseDescription": {
                // required: 'Een goede en professionele releasebeschrijving kan een verschil maken.',
                "length": 'Een releasebeschrijving moet minimaal 100 en maximaal 600 tekens lang zijn.'
            },
            "releaseArtwork": {
                "required": 'Het artwork is verplicht',
                "wrongSpecsAndColor": 'Verkeerde afbeeldingsspecificaties en kleurformaat. De releasehoes moet exact 3000 x 3000 px zijn, RGB-kleuren, JPG, maximale bestandsgrootte 4 MB.',
                "wrongColorFormat": 'Verkeerd kleurformaat van de afbeelding. De releasehoes moet in RGB-kleuren zijn. JPG, maximale bestandsgrootte 4 MB.',
                "wrongSpecs": 'Verkeerde afbeeldingsspecificaties. De releasehoes moet exact 3000 x 3000 px zijn. JPG, maximale bestandsgrootte 4 MB.',
                "meetsSpecs": 'Afbeelding voldoet aan alle specificaties.',
                "chooseImage": 'Kies een afbeelding',
                "fileTooLarge": 'Het geselecteerde bestand is groter dan 4 MB. Upload de hoes in 3000x3000 px, JPG, RGB-kleuren, maximale bestandsgrootte 4 MB',
                "wrongExtension": 'Verkeerde bestandsextensie. Het geselecteerde bestand heeft de extensie ".jpeg". Upload de hoes in 3000x3000 px, JPG (alleen extensie ".jpg"), RGB-kleuren, maximale bestandsgrootte 4 MB'
            },
            "releaseTerritories": {
                "required": 'Selecteer gebieden.'
            },
            "atleastOneCountrySelected": {
                "required": 'Selecteer ten minste één land.'
            },
            "atleastOneContentIDChoiceSelected": {
                "required": 'Youtube Content ID-verklaring is verplicht, selecteer een van de bovenstaande opties.'
            },
            "originalReleaseDate": {
                "required": 'Selecteer de oorspronkelijke releasedatum voor alle winkels wereldwijd.'
            },
            "officialReleaseDate": {
                "required": 'Selecteer de officiële releasedatum voor alle winkels wereldwijd.'
            },
            "atleastOneMainArtist": {
                "required": 'Er moet ten minste één artiest hoofdartiest zijn'
            },
            "featuringArtistMissing": {
                "required": 'De release moet de vermelde gastartiest correct toegewezen hebben als gastartiest. Pas aan en dien opnieuw in.'
            },
            "duplicateArtists": {
                "required": 'Er zijn twee of meer artiesten met dezelfde naam.'
            },
            "artistName": {
                "required": 'Selecteer artiest'
            },
            "artistType": {
                "required": 'Selecteer artiesttype'
            },
            "trackName": {
                "required": 'Typ de tracknaam'
            },
            "trackMixName": {
                "required": 'Typ de mixnaam',
                "regexp": 'De mixnaam mag alleen bestaan uit alfabetische tekens, cijfers, spaties en underscores'
            }
    },
    "update": {
        "releaseName": {
            "required": 'De naam van de release is verplicht',
            "length": 'De naam van de release moet meer dan 2 en minder dan 120 tekens lang zijn',
            "noForwardSlash": 'De naam van de release mag geen schuine streep (/) bevatten',
            "matchTrack": 'Voor een release met één nummer moet de naam van de release overeenkomen met het nummer.',
            "validCharacters": 'De naam van de release mag alleen bestaan uit alfabetische tekens, cijfers, spaties en underscores'
        },
        "releaseVersion": {
            "length": 'De versie van de release moet meer dan 2 en minder dan 120 tekens lang zijn',
            "validCharacters": 'De versie van de release mag alleen bestaan uit alfabetische tekens, cijfers, spaties en underscores',
            "missingOne": 'Je release bestaat uit slechts één nummer dat geen Original Mix is, daarom moet de aangepaste track mixnaam worden ingevoerd in de Release Versie.',
            "missingTwo": 'Als een release meer inhoud biedt dan de standaardversie of het een andere versie is van een al uitgebracht album/release, moet je de Release Versie invoeren.',
            "invalid": 'Voor een release met één nummer zonder Mix Naam (Original Mix), moet de Release Versie leeg worden gelaten. Wis de Release Versie of voeg een Mix Naam toe aan het nummer.'
        },
        "releaseLanguage": {
            "required": 'Releasetaal is verplicht. Selecteer de taal van je releasenaam.'
        },
        "releaseEAN_UPC": {
            "required": "EAN / UPC is vereist.",
            "length": "Het EAN-nummer moet precies 13 tekens lang zijn.",
            "isValidEAN": "De waarde is geen geldige EAN. Als u een nieuwe release invoert, voer dan een correcte EAN in. Als u een backcatalogus uploadt en de EAN is ongeldig, neem dan contact met ons op."
        },
        "releaseLabel": {
            "required": 'Selecteer je label.'
        },
        "releaseCopyright": {
            "required": 'Je moet de Copyright Eigenaar selecteren. Meestal is dat je label.'
        },
        "releaseCopyrightYear": {
            "required": 'Voer het copyrightjaar in waarin deze release zal worden (werd) gepubliceerd.',
            "regexp": 'Voer het geldige copyrightjaar in'
        },
        "releaseCopyrightPublisher": {
            "required": 'Je moet de Uitgever Eigenaar invoeren. Meestal is dat je label.'
        },
        "releaseCopyrightYearPublisher": {
            "required": 'Voer het copyrightjaar in waarin deze release zal worden (werd) gepubliceerd.',
            "regexp": 'Voer het geldige copyrightjaar in'
        },
        "releaseGenre": {
            "required": 'Selecteer je release Genre.'
        },
        "releaseSubGenre": {
            "required": 'Selecteer je release Sub-Genre'
        },
        "releaseCatalogNumber": {
            "required": 'Voer een uniek release catalogusnummer in.',
            "length": 'Minimaal 4 en maximaal 16 tekens.',
            "validFormat": 'Voer je categorienummer in zonder spaties, alleen HOOFDLETTERS en cijfers. De eerste twee tekens moeten HOOFDLETTERS zijn. MM001, MMD001, MM0001 ...'
        },
        "releaseDescription": {
            "length": 'Een releasebeschrijving moet minimaal 100 en maximaal 600 tekens lang zijn.'
        },
        "releaseArtwork": {
            "required": 'Het artwork is verplicht',
            "wrongSpecsAndColor": 'Verkeerde afbeeldingsspecificaties en kleurformaat. De releasehoes moet exact 3000 x 3000 px zijn, RGB-kleuren, JPG, maximale bestandsgrootte 4 MB.',
            "wrongColorFormat": 'Verkeerd kleurformaat van de afbeelding. De releasehoes moet in RGB-kleuren zijn. JPG, maximale bestandsgrootte 4 MB.',
            "wrongSpecs": 'Verkeerde afbeeldingsspecificaties. De releasehoes moet exact 3000 x 3000 px zijn. JPG, maximale bestandsgrootte 4 MB.',
            "meetsSpecs": 'Afbeelding voldoet aan alle specificaties.',
            "chooseImage": 'Kies een afbeelding',
            "fileTooLarge": 'Het geselecteerde bestand is groter dan 4 MB. Upload de hoes in 3000x3000 px, JPG, RGB-kleuren, maximale bestandsgrootte 4 MB',
            "wrongExtension": 'Verkeerde bestandsextensie. Het geselecteerde bestand heeft de extensie ".jpeg". Upload de hoes in 3000x3000 px, JPG (alleen extensie ".jpg"), RGB-kleuren, maximale bestandsgrootte 4 MB'
        },
        "releaseTerritories": {
            "required": 'Selecteer gebieden.'
        },
        "atleastOneCountrySelected": {
            "required": 'Selecteer ten minste één land.'
        },
        "atleastOneContentIDChoiceSelected": {
            "required": 'Youtube Content ID-verklaring is verplicht, selecteer een van de bovenstaande opties.'
        },
        "originalReleaseDate": {
            "required": 'Selecteer de oorspronkelijke releasedatum voor alle winkels wereldwijd.'
        },
        "officialReleaseDate": {
            "required": 'Selecteer de officiële releasedatum voor alle winkels wereldwijd.'
        },
        "atleastOneMainArtist": {
            "required": 'Er moet ten minste één artiest hoofdartiest zijn'
        },
        "featuringArtistMissing": {
            "required": 'De release moet de vermelde gastartiest correct toegewezen hebben als gastartiest. Pas aan en dien opnieuw in.'
        },
        "duplicateArtists": {
            "required": 'Er zijn twee of meer artiesten met dezelfde naam.'
        },
        "artistName": {
            "required": 'Selecteer artiest'
        },
        "artistType": {
            "required": 'Selecteer artiesttype'
        },
        "trackName": {
            "required": 'Typ de tracknaam'
        },
        "trackMixName": {
            "required": 'Typ de mixnaam',
            "regexp": 'De mixnaam mag alleen bestaan uit alfabetische tekens, cijfers, spaties en underscores'
        }
    },
    "transfer": {
        "releaseName": {
            "required": "De naam van de release is verplicht",
            "length": "De naam van de release moet tussen 2 en 120 tekens zijn",
            "invalid": "De naam van de release mag geen schuine streep (/) bevatten"
        },
        "releaseVersion": {
            "length": "De versie van de release moet meer dan 2 en minder dan 120 tekens lang zijn",
            "regexp": "De versie van de release mag alleen bestaan uit alfabetische tekens, cijfers, spaties en underscores",
            "missingOne": "Je release bestaat uit slechts één nummer dat geen Original Mix is, daarom moet de aangepaste track mixnaam worden ingevoerd in de Release Versie.",
            "missingTwo": "Als een release meer inhoud biedt dan de standaardversie of het een andere versie is van een al uitgebracht album/release, moet je de Release Versie invoeren.",
            "invalid": "Voor een release met één nummer zonder Mix Naam (Original Mix), moet de Release Versie leeg worden gelaten. Wis de Release Versie of voeg een Mix Naam toe aan het nummer."
        },
        "releaseLanguage": {
            "required": "Releasetaal is verplicht. Selecteer de taal van je releasenaam."
        },
        "releaseLabel": {
            "required": "Selecteer je label."
        },
        "releaseCopyright": {
            "required": "Je moet de Copyright Eigenaar invoeren. Meestal is dat je label."
        },
        "releaseCopyrightYear": {
            "required": "Voer het copyrightjaar in waarin deze release zal worden (werd) gepubliceerd.",
            "regexp": "Voer het geldige copyrightjaar in"
        },
        "releaseCopyrightPublisher": {
            "required": "Je moet de Uitgever Eigenaar invoeren. Meestal is dat je label."
        },
        "releaseCopyrightYearPublisher": {
            "required": "Voer het copyrightjaar in waarin deze release zal worden (werd) gepubliceerd.",
            "regexp": "Voer het geldige copyrightjaar in"
        },
        "releaseGenre": {
            "required": "Selecteer je release Genre."
        },
        "releaseSubGenre": {
            "required": "Selecteer je release Sub-Genre."
        },
        "releaseCatalogNumber": {
            "required": "Voer een uniek release catalogusnummer in.",
            "length": "Minimaal 4 en maximaal 16 tekens.",
            "regexp": "Voer je categorienummer in zonder spaties, alleen HOOFDLETTERS en cijfers. De eerste twee tekens moeten HOOFDLETTERS zijn. MM001, MMD001, MM0001 ... "
        },
        "releaseDescription": {
            "length": "Een releasebeschrijving moet minimaal 100 en maximaal 600 tekens lang zijn."
        },
        "releaseArtwork": {
            "required": "Het artwork is verplicht",
            "invalidDimensionsAndColorFormat": "Verkeerde afbeeldingsspecificaties en kleurformaat. De releasehoes moet exact 3000 x 3000 px zijn, RGB-kleuren, JPG, maximale bestandsgrootte 4 MB.",
            "invalidColorFormat": "Verkeerd kleurformaat van de afbeelding. De releasehoes moet in RGB-kleuren zijn. JPG, maximale bestandsgrootte 4 MB.",
            "invalidDimensions": "Verkeerde afbeeldingsspecificaties. De releasehoes moet exact 3000 x 3000 px zijn. JPG, maximale bestandsgrootte 4 MB.",
            "valid": "Afbeelding voldoet aan alle specificaties",
            "choose": "Kies een afbeelding",
            "fileSize": "Het geselecteerde bestand is groter dan 4 MB. Upload de hoes in 3000x3000 px, JPG, RGB-kleuren, maximale bestandsgrootte 4 MB",
            "fileExtension": "Verkeerde bestandsextensie. Het geselecteerde bestand heeft de extensie '.jpeg'. Upload de hoes in 3000x3000 px, JPG (alleen extensie '.jpg'), RGB-kleuren, maximale bestandsgrootte 4 MB'"
        },
        "releaseTerritories": {
            "required": "Selecteer gebieden."
        },
        "atleastOneCountrySelected": {
            "required": "Selecteer ten minste één land."
        },
        "atleastOneContentIDChoiceSelected": {
            "required": "Youtube Content ID-verklaring is verplicht, selecteer een van de bovenstaande opties."
        },
        "originalReleaseDate": {
            "required": "Selecteer de oorspronkelijke releasedatum voor alle winkels wereldwijd."
        },
        "officialReleaseDate": {
            "required": "Selecteer de officiële releasedatum voor alle winkels wereldwijd."
        },
        "atleastOneMainArtist": {
            "required": "Er moet ten minste één artiest hoofdartiest zijn"
        },
        "artistType": {
            "required": "Selecteer artiesttype"
        },
        "trackName": {
            "required": "Typ de tracknaam"
        },
        "trackMixName": {
            "required": "Typ de mixnaam",
            "regexp": "De mixnaam mag alleen bestaan uit alfabetische tekens, cijfers, spaties en underscores"
        }
    }
};

export default releasesValidationNL;